import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

const ColumnToggle = ({ columns, visibleColumns, onToggleColumn, onToggleAll }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const allVisible = visibleColumns.length === columns.length;
  const someVisible = visibleColumns.length > 0 && visibleColumns.length < columns.length;

  return (
    <div className="dropdown" ref={dropdownRef}>
      <button
        className="btn btn-outline-primary dropdown-toggle"
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        title="Toggle Columns"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="icon" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
          <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
          <path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"/>
          <path d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"/>
          <path d="M9 12l.01 0"/>
          <path d="M13 12l2 0"/>
          <path d="M9 16l.01 0"/>
          <path d="M13 16l2 0"/>
        </svg>
        Columns
      </button>
      {isOpen && (
        <div className="dropdown-menu show" style={{ maxHeight: '300px', overflowY: 'auto', zIndex: 1050 }}>
          <div className="dropdown-item">
            <label className="form-check mb-0">
              <input
                className="form-check-input"
                type="checkbox"
                checked={allVisible}
                ref={(input) => {
                  if (input) {
                    input.indeterminate = someVisible;
                  }
                }}
                onChange={() => onToggleAll(!allVisible)}
              />
              <span className="form-check-label fw-bold">
                {allVisible ? 'Hide All' : 'Show All'}
              </span>
            </label>
          </div>
          <div className="dropdown-divider"></div>
          {columns.map((column) => {
            const isVisible = visibleColumns.includes(column.key);
            return (
              <div key={column.key} className="dropdown-item">
                <label className="form-check mb-0">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={isVisible}
                    onChange={() => onToggleColumn(column.key)}
                  />
                  <span className="form-check-label">{column.label}</span>
                </label>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

ColumnToggle.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  visibleColumns: PropTypes.arrayOf(PropTypes.string).isRequired,
  onToggleColumn: PropTypes.func.isRequired,
  onToggleAll: PropTypes.func.isRequired,
};

export default ColumnToggle;


